/* eslint-disable import/prefer-default-export */
export const getCookie = (name) => {
  if (typeof document === 'undefined') return ''

  const cookies = document.cookie ? document.cookie.split('; ') : []
  const cookie = cookies.find((item) => item.startsWith(`${name}=`))

  if (!cookie) return ''

  return decodeURIComponent(cookie.split('=').slice(1).join('='))
}
